<div class="">
  <div class="d-flex align-items-center gap-3 mb-3">
    <h6 class="mb-0" i18n>Taxes</h6>
    <div class="flex-fill"></div>
    <button (click)="addTax()" class="btn btn-secondary-info" type="button">
      <i class="far fa-plus"></i> <ng-container i18n>Add Tax</ng-container>
    </button>
    <div class="dropdown" dropdown>
      <button class="btn btn-secondary-primary dropdown-toggle" dropdownToggle type="button">
        <i class="fal fa-copy"></i>
        <ng-container i18n>Copy</ng-container>
      </button>
      <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
        <li>
          <button
            (click)="onCopyFrom()"
            matTooltip="Ability to copy taxes from rental(s) to your selected rental."
            matTooltipPosition="left"
            i18n-matTooltip
          >
            <i class="fal fa-copy"></i> <ng-container i18n>Copy from Rental</ng-container>
          </button>
        </li>
        <li>
          <button
            (click)="onCopyTo()"
            matTooltip="Ability to copy taxes to rental(s) from your selected rental."
            matTooltipPosition="left"
            i18n-matTooltip
          >
            <i class="fal fa-paste"></i> <ng-container i18n>Copy to Rental</ng-container>
          </button>
        </li>
      </ul>
    </div>
    <button (click)="onSave(form)" type="button" class="btn btn-secondary-info">
      <span class="cs-icon cs-icon-save"></span>
      <ng-container i18n>Save</ng-container>
    </button>
  </div>
  <div class="alert alert-secondary-info">
    <i class="fal fa-info-circle alert-icon"></i>
    <div class="alert-content" i18n>
      Change taxes associated with this rental. These adjustments will apply to any booking not imported from channels
      where these taxes are charged to the guest up front.
    </div>
  </div>
  <form [formGroup]="form" class="d-flex flex-column gap-3">
    <div formArrayName="taxes" *ngFor="let item of taxes.controls; let i = index" class="container-box p-3">
      <div [formGroupName]="i" class="row">
        <div class="col-sm-3">
          <mat-form-field2 class="mat-block">
            <input
              type="text"
              formControlName="name"
              placeholder="Name"
              i18n-placeholder
              matInput
              required
              [matAutocomplete]="autoName"
            />
            <mat-autocomplete
              autoActiveFirstOption
              #autoName="matAutocomplete"
              (optionSelected)="onAccountTaxSelected($event.option.value, item)"
            >
              <mat-option *ngFor="let option of availableTaxes" [value]="option">
                {{ option.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field2>
        </div>
        <div class="col-sm-2">
          <mat-form-field2 class="mat-block">
            <mat-label
              ><span [innerHtml]="item['controls'].type.value | amountPlaceholder : currencySymbol"></span
            ></mat-label>
            <input type="number" min="0" formControlName="amount" required matInput />
            <mat-error *ngIf="item['controls'].amount.touched && item.hasError('required', ['amount'])">
              <ng-container i18n>Amount is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-sm-2">
          <mat-form-field2 class="mat-block">
            <mat-select formControlName="type" placeholder="Amount Type" i18n-placeholder>
              <mat-option value="percent" i18n>Percent</mat-option>
              <mat-option value="flat" i18n>Flat</mat-option>
            </mat-select>
          </mat-form-field2>
        </div>
        <div class="col-sm-2">
          <mat-form-field2 class="mat-block">
            <mat-select formControlName="tax_type" placeholder="Tax Type" i18n-placeholder required>
              <mat-option value="pass_through_hotel_tax" i18n>Hotel Tax</mat-option>
              <mat-option value="pass_through_lodging_tax" i18n>Lodging Tax</mat-option>
              <mat-option value="pass_through_room_tax" i18n>Room Tax</mat-option>
              <mat-option value="pass_through_tourist_tax" i18n>Tourist Tax</mat-option>
              <mat-option value="pass_through_transient_occupancy_tax" i18n>Transient Occupancy Tax</mat-option>
              <mat-option value="pass_through_sales_tax" i18n>Sales Tax</mat-option>
              <mat-option value="pass_through_vat_gst" i18n>VAT / GST</mat-option>
              <mat-option value="pass_through_tourism_assessment_fee" i18n>Tourism Assessment Fee</mat-option>
            </mat-select>
            <mat-error *ngIf="item['controls'].tax_type.touched && item.hasError('required', ['tax_type'])">
              <ng-container i18n>Tax Type is required</ng-container>
            </mat-error>
          </mat-form-field2>
        </div>
        <div class="col-sm-2">
          <mat-form-field2 class="mat-block">
            <mat-select
              formControlName="modality"
              placeholder="Modality"
              i18n-placeholder
              matTooltip="Modality determines how the fees is applied to the booking."
              matTooltipPosition="above"
              i18n-matTooltip
            >
              <mat-option [value]="taxV3Modalities.PerStay">{{
                taxV3ModalityLabels[taxV3Modalities.PerStay]
              }}</mat-option>
              <mat-option [value]="taxV3Modalities.PerNight">{{
                taxV3ModalityLabels[taxV3Modalities.PerNight]
              }}</mat-option>
              <mat-option [value]="taxV3Modalities.PerPerson">{{
                taxV3ModalityLabels[taxV3Modalities.PerPerson]
              }}</mat-option>
              <mat-option [value]="taxV3Modalities.PerPersonPerNight">{{
                taxV3ModalityLabels[taxV3Modalities.PerPersonPerNight]
              }}</mat-option>
            </mat-select>
          </mat-form-field2>
        </div>

        <!--            <div class="col-sm-1"></div>-->
        <!--            <div class="col-sm-4">-->
        <!--              <mat-form-field2 class="mat-block">-->
        <!--                <span matPrefix><i matTooltip="Airbnb exclusive feature" class="fab fa-airbnb"></i></span>-->
        <!--                <input type="text" formControlName="business_tax_id" matInput placeholder="Business Tax Id" />-->
        <!--              </mat-form-field2>-->
        <!--            </div>-->
        <!--            <div class="col-sm-4">-->
        <!--              <mat-form-field2 class="mat-block">-->
        <!--                <span matPrefix><i matTooltip="Airbnb exclusive feature" class="fab fa-airbnb"></i></span>-->
        <!--                <input-->
        <!--                  type="text"-->
        <!--                  formControlName="tot_registration_id"-->
        <!--                  matInput-->
        <!--                  placeholder="Accommodations tax registration number"-->
        <!--                />-->
        <!--              </mat-form-field2>-->
        <!--            </div>-->
        <!--            <div class="col-sm-3">-->
        <!--              <mat-form-field2 class="mat-block">-->
        <!--                <span matPrefix><i matTooltip="Airbnb exclusive feature" class="fab fa-airbnb"></i></span>-->
        <!--                <input-->
        <!--                  type="number"-->
        <!--                  formControlName="long_term_stay_exemption"-->
        <!--                  matInput-->
        <!--                  step="1"-->
        <!--                  placeholder="Long term stay exemption"-->
        <!--                />-->
        <!--              </mat-form-field2>-->
        <!--            </div>-->
        <div class="col-sm-1">
          <button
            (click)="removeTax(i)"
            class="btn btn-secondary-danger align-input-row-end"
            type="button"
            matTooltip="Remove Tax"
            i18n-matTooltip
          >
            <i class="cs-icon cs-icon-trash"></i>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
